import React, { useState } from 'react';
import ShareModal from './ShareModal';

function Partage({ p_link, p_buttonClassName = 'kdo-home-button', p_buttonContent = 'Partager', p_buttonLabel }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                className={p_buttonClassName}
                aria-label={p_buttonLabel}
                title={p_buttonLabel}
                onClick={() => {
                    if (window.umami) window.umami.track('share-All');
                    setIsOpen(true);
                }}
            >
                {p_buttonContent}
            </button>
            {isOpen && (
                <ShareModal
                    link={p_link}
                    title="Partager toutes mes listes"
                    intro="Envoyez ce lien à vos proches : ils verront l'ensemble de vos listes."
                    hint="Pour ne partager qu'une seule liste, utilisez le bouton de partage depuis cette liste."
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}

export default Partage;
